module.exports = {
    API_BASE_URL: "https://us-central1-yasa-21022022.cloudfunctions.net",
    // WEB_SOCKET_URL: "https://yasa-21022022.uc.r.appspot.com",
    // WEB_SOCKET_URL: "https://development-dot-yasa-21022022.uc.r.appspot.com"
};
  